import { useTranslation } from "react-i18next";
import { useStore } from "@/store";
import { getPeerUrl, getWebappUrl } from "@/utils/urlHelpers";
import useInitializationParams from "./useInitializationParams";
import useNavigationHelpers from "./useNavigationHelpers";

export default function useAssessmentFlowUrl() {
	const { i18n } = useTranslation();
	const sessionId = useStore((state) => state.sessionId);
	const configId = useStore((state) => state.configId);
	const { locationId, partnerToken } = useInitializationParams();
	const functionalAssessmentExecution = useStore((state) => state.config?.functionalAssessmentExecution);
	const { currentPage } = useNavigationHelpers();

	const url =
		currentPage === "webapp-assessment" && functionalAssessmentExecution === "external"
			? getWebappUrl(i18n.language, configId, sessionId)
			: getPeerUrl(i18n.language, configId, partnerToken, locationId, sessionId, { skipPairing: true });

	return url;
}
